import { ADD_KINDS } from "../../shared/addKinds";

// The things a task can be for besides a goal and a Key Date (Craig, 26 Oct 2026: "I think we need the ability to add
// Tasks to Fears and Dreams so that the user can see what they are on the Radar page and quickly add the tasks to
// Today"). A task names at most one dream and one fear, on the task only, as it names a Key Date: deleting the dream or
// fear clears the field on its tasks and keeps them. Keyed by the dream's or fear's kind.
export const TASK_LINKS = {
  dreams: { field: "dreamId", one: "dream" },
  fears:  { field: "fearId",  one: "fear" },
};

// The tasks that name this dream or fear (`link`, an entry of TASK_LINKS): unfinished first, then by deadline, soonest
// first, then the undated ones.
export const linkedTasks = (tasks, link, id) => (tasks || [])
  .filter(t => t[link.field] === id)
  .sort((a, b) => Number(!!a.done) - Number(!!b.done)
    || (a.deadline ? 0 : 1) - (b.deadline ? 0 : 1)
    || (a.deadline || "").localeCompare(b.deadline || ""));

// The dream or fear a task editor saves. Until the list has loaded (or if it couldn't), the one the task already has,
// so Save never clears a link it couldn't check; once loaded, none if that dream or fear has been deleted.
export const keptLink = (options, loaded, id) => {
  if (!id) return null;
  if (!loaded) return id;
  return options.some(o => o.id === id) ? id : null;
};

// What a task is linked to besides its goal, in this order, each as { kind, name, icon, hueName }: kind ("Key date",
// "Dream", "Fear") is read aloud before the name, and the row shows the kind's icon in its hue (the + sheet's) in its
// place. Named by kind, because "For <fear>" would read as working toward the fear. `names` maps each field (keyDateId,
// dreamId, fearId) to a Map of id → words; a link to something deleted is left out.
// [field, kind, the + sheet's kind for its icon and hue], looked up once so a renamed kind fails here, not on every row.
const LINK_KINDS = [["keyDateId", "Key date", "keydate"], ["dreamId", "Dream", "dream"], ["fearId", "Fear", "fear"]].map(([field, kind, addKind]) => {
  const add = ADD_KINDS.find(k => k.id === addKind);
  if (!add) throw new Error(`taskLinks: no + sheet kind "${addKind}"`);
  return { field, kind, icon: add.tile, hueName: add.hueName };
});
export const linksOfTask = (task, names) => LINK_KINDS.flatMap(({ field, kind, icon, hueName }) => {
  const name = names[field]?.get(task[field]);
  return name ? [{ kind, name, icon, hueName }] : [];
});
